export const GET_SYSYTEM_ALERT = "home/GET_SYSYTEM_ALERT";
export const SET_SYSTEM_ALERT = "home/SET_SYSTEM_ALERT";

export const getSystemAlert = () => {
  return {
    type: GET_SYSYTEM_ALERT,
  };
};

export const setSystemAlert = (data) => {
  return {
    type: SET_SYSTEM_ALERT,
    payload: data,
  };
};
